@use '../../styles/config.module' as *;

@mixin scrollbar {
  &::-webkit-scrollbar {
    background-color: rgba(gray, 0.2);
  }
  &::-webkit-scrollbar-track {
    background-color: rgba($color-divider, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background-color: $color-primary;
    &:hover {
      background-color: $color-primary;
    }
  }
}

@-moz-document url-prefix() {
  .root {
    scrollbar-color: $color-primary $color-divider;
    scrollbar-width: thin;
  }
}

.root {
  &::-webkit-scrollbar {
    width: 0.6rem;
    height: 0.6rem;
    background-color: transparent;
    border-radius: 0.6rem;
    cursor: pointer;
  }

  &::-webkit-scrollbar-track {
    border-radius: 0.4rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.7rem;
    background-color: transparent;
  }

  &.all,
  &:hover {
    @include scrollbar;
  }
  &.small {
    &::-webkit-scrollbar {
      width: 0.2rem;
      height: 0.2rem;
    }
  }
}
